export * from './IID';
export * from './RESTArray';
export * from './RESTObject';
export * from './OAuth2Service';
export * from './WebSocket';
export * from './rest.module';
export * from './ITokenStore';
export * from './RESTConfig';
export * from './CookieTokenStore';



// WEBPACK FOOTER //
// ./src/app/angular-rest/index.ts